import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { ButtonsModule } from '@shared/core/components/buttons';
import { TextModule } from '@shared/core/components/text';
import { LinkModule } from '@shared/core/components/link';
import { ImagePreloadDirectiveSharedModule } from '@shared/core/directives/imagePreload';
import { FormForTableNumberModule } from '@shared/core/modules/forms/formTypes/forTableNumber';

import { ModalsTypesModule } from '../../modalsTypes';

import { ModalForDineInComponent } from './modal-for-dine-in.shared.component';

@NgModule({
    declarations: [
        ModalForDineInComponent,
    ],
    imports: [
        CommonModule,
        ModalsTypesModule,
        HeadersModule,
        ButtonsModule,
        TextModule,
        LinkModule,
        FormForTableNumberModule,
        ImagePreloadDirectiveSharedModule,
    ],
    exports: [
        ModalForDineInComponent,
    ],
})
export class ModalForDineInModule { }
